module.exports = __webpack_public_path__ + "static/media/d13kz.c02cc9b1.pdf";